import { User, UserBatch } from '@models';

export interface UserState {
  users: User[];
  batches: UserBatch[];
  selectedMapUserIds: string[];
  fetchedAt: Date | null;
  batchesFetchedAt: Date | null;
}

export const initialUserState: UserState = {
  users: [],
  batches: [],
  selectedMapUserIds: [],
  fetchedAt: null,
  batchesFetchedAt: null,
};
